import Api from "../axios";

export default async function apiRunJob() {
  return await Api.get("/run_job");
}
